import { render } from "./recover-password.vue?vue&type=template&id=78a672b9"
import script from "./recover-password.vue?vue&type=script&lang=js"
export * from "./recover-password.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__